export default "__VITE_ASSET__03a36a95__"